module.exports = __webpack_public_path__ + "img/logo_list.c7e5c6be.png";